import { ENVIRONMENT } from "@helper/getEnvVariables";
import { getErrorMessage } from "@helper/getErrorMessage";
import { User } from "@hooks/useMySPHLightbox";
import { OKTAUserTypeEnum } from "@hooks/useUserInfo";
import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";

export interface UserStore {
  userInfo: OKTAUserType;
  setUserInfo: (userInfo: OKTAUserType) => void;
  userError: unknown;
  setUserError: (error: ReturnType<typeof getErrorMessage>) => void;
  isUserLoading: boolean;
  setUserLoading: (loading: boolean) => void;
  successful: boolean;
  setSuccessful: (loading: boolean) => void;
}

export type OKTAUserType =
  | (User & {
      mysphw?: string;
      usertype?: OKTAUserTypeEnum;
      svc?: string;
    })
  | null;

/**
 * Enable devs to use the Redux dev tools to check the state store when accessing through UAT
 */
function createState<T>(fn: StateCreator<T>) {
  if (ENVIRONMENT === "prd") {
    return create<T>(fn);
  }
  return create(devtools(fn));
}

const useOKTAUserStore = createState<UserStore>((set) => ({
  userInfo: null,
  setUserInfo: (userInfo: OKTAUserType) => {
    set({ userInfo });
  },
  userError: "",
  setUserError: (error: ReturnType<typeof getErrorMessage>) => {
    set({ userError: error });
  },
  isUserLoading: true,
  setUserLoading: (value: boolean) => {
    set(() => ({ isUserLoading: value }));
  },
  successful: false,
  setSuccessful: (value: boolean) => {
    set(() => ({ successful: value }));
  },
}));

export default useOKTAUserStore;
